import { SlingoStyle } from "@lib/titan2-slingo/dist/game/view/abstract/style/SlingoStyle";
import { LoaderStyle } from "@lib/titan2/dist/game/view/style/CommonStyle";
/**
 * GameStyle.ts
 */
export class GameStyle extends SlingoStyle {
}
GameStyle.MESSAGE_BAR_BACKGROUND = "MessageBarBackground";
GameStyle.PAY_TABLE_WIN_ICON_HUNT_TOP = "LadderCrabHunticonTOP";
GameStyle.PAY_TABLE_WIN_ICON_FISH_TOP = "LadderCrabFishingTOP";
GameStyle.PAY_TABLE_WIN_ICON_PICK_TOP = "LadderPickiconTOP";
GameStyle.PAY_TABLE_WIN_ICON_HUNT_REG = "LadderCrabHuntIconREGULAR";
GameStyle.PAY_TABLE_WIN_ICON_FISH_REG = "LadderCrabFishingREGULAR";
GameStyle.PAY_TABLE_WIN_ICON_PICK_REG = "LadderPickiconREGULAR";
GameStyle.PAY_TABLE_ORNAMENT = "PayTableDetail";
GameStyle.MINI_PAY_TABLE_ORNAMENT = "MiniPayTableDetail";
GameStyle.TICKET_BACKGROUND = "GridBack";
GameStyle.TICKET_SYMBOL_BUTTON = "TicketSymbol";
GameStyle.REEL_SYMBOL_ANIMATION = "Symbols";
GameStyle.COLLECT_BUTTON = "PurchaseSpinsCollectButton";
GameStyle.END_GAME_BUTTON = "PurchaseSpinsCollectButton";
GameStyle.LOGO = "Logo";
GameStyle.BIG_WIN_ANIMATION = "celebrations_anima";
GameStyle.FULL_HOUSE_ANIMATION = "celebrations_anima";
GameStyle.SCATTER_WIN_ANIMATION = "celebrations_anima";
GameStyle.COLLECTIBLE = "CL";
GameStyle.COIN = "C";
GameStyle.SCATTER = "SC";
GameStyle.GAME_SUMMARY_ORNAMENT_RESULT = "TitleResultsGraphic";
GameStyle.GAME_SUMMARY_ORNAMENT_WIN = "TitleWinGraphic";
GameStyle.GAME_SUMMARY_ORNAMENT_BIG_WIN = "TitleBigWinGraphic";
GameStyle.FEATURE_START_PANEL = "TransitionFeatureBase";
GameStyle.FEATURE_START_PANEL_IMG = "TransitionFeatureIcon";
//////////////////////////////////////////////////////////////////////
GameStyle.FULL_HOUSE_IN_LANDSCAPE = "fh-in";
GameStyle.FULL_HOUSE_IN_PORTRAIT = "fh-in";
GameStyle.FULL_HOUSE_LOOP_LANDSCAPE = "fh-loop";
GameStyle.FULL_HOUSE_LOOP_PORTRAIT = "fh-loop";
GameStyle.FULL_HOUSE_OUT_LANDSCAPE = "fh-out";
GameStyle.FULL_HOUSE_OUT_PORTRAIT = "fh-out";
GameStyle.BIG_WIN_IN_LANDSCAPE = "bw-in";
GameStyle.BIG_WIN_IN_PORTRAIT = "bw-in";
GameStyle.BIG_WIN_LOOP_LANDSCAPE = "bw-loop";
GameStyle.BIG_WIN_LOOP_PORTRAIT = "bw-loop";
GameStyle.BIG_WIN_OUT_LANDSCAPE = "bw-out";
GameStyle.BIG_WIN_OUT_PORTRAIT = "bw-out";
GameStyle.WIN_IN_LANDSCAPE = "win-in";
GameStyle.WIN_IN_PORTRAIT = "win-in";
GameStyle.WIN_LOOP_LANDSCAPE = "win-loop";
GameStyle.WIN_LOOP_PORTRAIT = "win-loop";
GameStyle.WIN_OUT_LANDSCAPE = "win-out";
GameStyle.WIN_OUT_PORTRAIT = "win-out";
GameStyle.MEGA_WIN_IN_LANDSCAPE = "mw-in";
GameStyle.MEGA_WIN_IN_PORTRAIT = "mw-in";
GameStyle.MEGA_WIN_LOOP_LANDSCAPE = "mw-loop";
GameStyle.MEGA_WIN_LOOP_PORTRAIT = "mw-loop";
GameStyle.MEGA_WIN_OUT_LANDSCAPE = "mw-out";
GameStyle.MEGA_WIN_OUT_PORTRAIT = "mw-out";
GameStyle.HUGE_WIN_IN_LANDSCAPE = "hw-in";
GameStyle.HUGE_WIN_IN_PORTRAIT = "hw-in";
GameStyle.HUGE_WIN_LOOP_LANDSCAPE = "hw-loop";
GameStyle.HUGE_WIN_LOOP_PORTRAIT = "hw-loop";
GameStyle.HUGE_WIN_OUT_LANDSCAPE = "hw-out";
GameStyle.HUGE_WIN_OUT_PORTRAIT = "hw-out";
GameStyle.BACKGROUND_LANDSCAPE = "Landscape-Background";
GameStyle.REELS_FRAME = "ReelsFrame";
GameStyle.FEATURE_REEL = "FeatureReel";
GameStyle.PAY_TABLE_ICON_12 = "PayTableGold";
GameStyle.PAY_TABLE_ICON_10 = "PayTableSilver";
GameStyle.PAY_TABLE_ICON_9 = "PayTableBronze";
GameStyle.PAY_TABLE_ICON_8 = "PaytableWheel05";
GameStyle.PAY_TABLE_ICON_7 = "PaytableWheel04";
GameStyle.PAY_TABLE_ICON_6 = "PaytableWheel03";
GameStyle.PAY_TABLE_ICON_5 = "PaytableWheel02";
GameStyle.PAY_TABLE_ICON_4 = "PaytableWheel01";
GameStyle.AVAILABLE_WIN_ICON_WHEEL_BRONZE_1_20K = "Wheel-01-20k";
GameStyle.AVAILABLE_WIN_ICON_WHEEL_BRONZE_2_20K = "Wheel-02-20k";
GameStyle.AVAILABLE_WIN_ICON_WHEEL_BRONZE_3_20K = "Wheel-03-20k";
GameStyle.AVAILABLE_WIN_ICON_WHEEL_SILVER_20K = "Wheel-04-20k";
GameStyle.AVAILABLE_WIN_ICON_WHEEL_GOLD_20K = "Wheel-05-20k";
GameStyle.AVAILABLE_WIN_ICON_SLOTS_BRONZE = "PayTableBronze";
GameStyle.AVAILABLE_WIN_ICON_SLOTS_SILVER = "PayTableSilver";
GameStyle.AVAILABLE_WIN_ICON_SLOTS_GOLD = "PayTableGold";
GameStyle.SUMMARY_BACKGROUND = "WinDisplay";
GameStyle.SUMMARY_BACKGROUND_RESULTS = "1_resultsSweep";
GameStyle.SUMMARY_BACKGROUND_SMALL_WIN = "2_smallWinSweep";
GameStyle.SUMMARY_BACKGROUND_NORMAL_WIN = "3_normalSweep";
GameStyle.SUMMARY_BACKGROUND_BIG_WIN = "4_bigWinSweep2";
GameStyle.SUMMARY_BACKGROUND_FULL_HOUSE = "5_fullHouseSweep";
GameStyle.SUMMARY_BACKGROUND_GAME_OVER = "game_over";
GameStyle.SPINS_REMAINING_BG = "SpinsRemainingBg";
GameStyle.FREE_SPINS_REMAINING_BG = "FreeSpinsRemainingBg";
GameStyle.SCATTER_PANEL_ANIMATION = "ScatterPanel";
GameStyle.SCATTER_PANEL_JOKER_ICON_0 = "ReelSymbolSuperWild";
GameStyle.SCATTER_PANEL_JOKER_ICON_1 = "ReelSymbolWild";
GameStyle.SCATTER_PANEL_COIN_ICON_0 = "ReelSymbolCoin";
GameStyle.SPINS_COUNTER_FLOWER_ANIMATION = "SpinsCounter";
GameStyle.FREE_SPINS_COUNTER_FLOWER_ANIMATION = "FreespinsCounter";
GameStyle.TOTAL_WIN_COUNTER_BACKGROUND = "WinPanel";
/**
 * GameLoaderStyle.ts
 */
export class GameLoaderStyle extends LoaderStyle {
}
GameLoaderStyle.BG_ANIMATION = "Background";
GameLoaderStyle.PROGRESS_BAR_FOREGROUND = "ProgressBarForeground";
GameLoaderStyle.BACKGROUND = "Background";
GameLoaderStyle.OVERLAY = "Overlay";
GameLoaderStyle.OVERLAY_GREAT_WESTERN = "Overlay-GreatWestern";
/**
 * GameHelpSnapshot.ts
 */
export class GameHelpSnapshot {
}
GameHelpSnapshot.START_GAME_BUTTON = "GameHelpSnapshot.StartGameButton";
GameHelpSnapshot.PURCHASE_SPIN_BUTTON = "GameHelpSnapshot.PurchaseSpinButton";
GameHelpSnapshot.AVAILABLE_WIN_DISPLAY_LANDSCAPE = "GameHelpSnapshot.AvailableWinDisplayLandscape";
GameHelpSnapshot.AVAILABLE_WIN_DISPLAY_PORTRAIT = "GameHelpSnapshot.AvailableWinDisplayPortrait";
GameHelpSnapshot.COLLECT = "GameHelpSnapshot.CollectButton";
GameHelpSnapshot.END_GAME = "GameHelpSnapshot.EndGameButton";
GameHelpSnapshot.STAKE_SELECTOR = "GameHelpSnapshot.StakeSelectorToggleButton";
GameHelpSnapshot.PAY_TABLE_IN_PROGRESS = "GameHelpSnapshot.PayTableInProgress";
GameHelpSnapshot.FREE_SPINS = "GameHelpSnapshot.FreeSpins";
GameHelpSnapshot.FREE_SPIN_SYMBOL = "GameHelpSnapshot.FreeSpinSymbol";
/**
 * FeatureStyle.ts
 */
export class FeatureStyle {
}
FeatureStyle.MODULE = "Bonus";
FeatureStyle.WIN_DISPLAY = "WinDisplay";
FeatureStyle.BLANK = "Blank";
//# sourceMappingURL=GameStyle.js.map